<template>
  <section id="about" class="about-section">
    <div class="section-title fade-in-up" :class="{ visible: isVisible }">
      <h2>{{ $t("about.title") }}</h2>
      <p>{{ $t("about.subtitle") }}</p>
    </div>
    <div class="about-container">
      <div class="about-content fade-in-up" :class="{ visible: isVisible }" style="transition-delay: 0.1s">
        <h3>{{ $t("about.companyProfile") }}</h3>
        <p>{{ $t("about.description1") }}</p>

        <p>{{ $t("about.description2") }}</p>

        <div class="about-stats">
          <div class="stat-item" v-for="(stat, index) in $t('about.stats')" :key="index">
            <div class="stat-number">{{ stat.number }}</div>
            <div class="stat-label">{{ stat.label }}</div>
          </div>
        </div>
      </div>
      <div class="about-image fade-in-up" :class="{ visible: isVisible }" style="transition-delay: 0.3s">
        <img src="@/assets/images/optimized/meeting.webp" alt="国际贸易" />
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "AboutSection",
  data() {
    return {
      isVisible: false,
    };
  },
  mounted() {
    this.observeSection();
  },
  methods: {
    observeSection() {
      const options = {
        threshold: 0.2,
        rootMargin: "0px 0px -100px 0px",
      };

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.isVisible = true;
          }
        });
      }, options);

      const section = this.$el;
      if (section) {
        observer.observe(section);
      }
    },
  },
};
</script>

<style scoped>
/* 关于我们区域 */
.about-section {
  padding: 100px 40px;
  background: linear-gradient(135deg, #f5f7fa 0%, #e8f4f8 100%);
}

/* 标题样式 */
.section-title {
  text-align: center;
  margin-bottom: 60px;
}

.section-title h2 {
  font-size: 42px;
  color: var(--section-title-color);
  margin-bottom: 15px;
  position: relative;
  display: inline-block;
}

.section-title h2::after {
  content: "";
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
  width: 80px;
  height: 4px;
  background: linear-gradient(135deg, var(--gradient-start), var(--gradient-end));
  border-radius: 2px;
}

.section-title p {
  color: #666;
  font-size: 18px;
  margin-top: 25px;
}

/* 容器样式 */
.about-container {
  max-width: 1400px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 80px;
  align-items: center;
}

/* 内容样式 */
.about-content h3 {
  font-size: 28px;
  color: var(--section-title-color);
  margin-bottom: 25px;
  position: relative;
  padding-bottom: 15px;
}

.about-content h3::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 60px;
  height: 3px;
  background: linear-gradient(135deg, var(--gradient-start), var(--gradient-end));
  border-radius: 2px;
}

.about-content p {
  color: #555;
  line-height: 2;
  font-size: 16px;
  margin-bottom: 20px;
  text-align: justify;
}

/* 统计数据样式 */
.about-stats {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 30px;
  margin-top: 50px;
}

.stat-item {
  text-align: center;
  padding: 30px;
  background: white;
  border-radius: 15px;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
}

.stat-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 30px rgba(49, 148, 178, 0.15);
}

.stat-number {
  font-size: 42px;
  font-weight: bold;
  background: linear-gradient(135deg, var(--gradient-start), var(--gradient-end));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin-bottom: 10px;
}

.stat-label {
  color: #666;
  font-size: 16px;
}

/* 图片样式 */
.about-image {
  position: relative;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
}

.about-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.5s ease;
}

.about-image:hover img {
  transform: scale(1.05);
}

/* 动画效果 */
.fade-in-up {
  opacity: 0;
  transform: translateY(30px);
  transition: all 0.8s ease;
}

.fade-in-up.visible {
  opacity: 1;
  transform: translateY(0);
}

/* 响应式设计 */
@media (max-width: 768px) {
  .about-section {
    padding: 60px 20px;
  }

  .section-title h2 {
    font-size: 32px;
  }

  .section-title p {
    font-size: 16px;
  }

  .about-container {
    grid-template-columns: 1fr;
    gap: 40px;
  }

  .about-content h3 {
    font-size: 24px;
  }

  .about-stats {
    grid-template-columns: 1fr;
    gap: 20px;
  }

  .stat-number {
    font-size: 32px;
  }

  .stat-label {
    font-size: 14px;
  }
}
</style>
